export default __webpack_public_path__ + "static/media/rmc04.19062cc5.png";